import { useState } from 'react';
import cookie from 'js-cookie';
import {
  CUSTOMER_STATE_ZIPCODE,
  getDefaultZipcodeState,
  isSameDestination,
  parseZipcodeState,
  ZipcodeStateData,
} from './customer-zipcode';

export type { ZipcodeStateData };

const cookieOptions = () =>
  ({
    expires: 365,
    path: '/',
    sameSite: 'lax',
    secure:
      typeof window !== 'undefined' && window.location.protocol === 'https:',
  } as const);

const takeFromLocalStorage = (): ZipcodeStateData | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const stored = parseZipcodeState(
      localStorage.getItem(CUSTOMER_STATE_ZIPCODE),
    );

    localStorage.removeItem(CUSTOMER_STATE_ZIPCODE);

    return stored;
  } catch {
    return null;
  }
};

export default function useCustomerZipCode() {
  const [data, setData] = useState<ZipcodeStateData | null>(null);

  const save = (formatedState: ZipcodeStateData) => {
    cookie.set(
      CUSTOMER_STATE_ZIPCODE,
      JSON.stringify(formatedState),
      cookieOptions(),
    );
    setData(formatedState);
  };

  const setDefaultData = () => {
    const defaultData = getDefaultZipcodeState();

    if (defaultData) {
      save(defaultData);
    }
  };

  const initialFetching = async () => {
    const fromCookie = parseZipcodeState(cookie.get(CUSTOMER_STATE_ZIPCODE));

    if (fromCookie) {
      save(fromCookie);

      return false;
    }

    const migrated = takeFromLocalStorage();

    if (!migrated) {
      setDefaultData();

      return false;
    }

    save(migrated);

    return !isSameDestination(migrated, getDefaultZipcodeState());
  };

  return {
    data,
    save,
    initialFetching,
  };
}
